import { connect } from 'react-redux';
import PatternBrowserCategory, { Props } from '../_components/PatternBrowserCategory';

export default connect(
	null,
	null
)(PatternBrowserCategory);